import * as React from 'react';

const ShareAndroidSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M18.906 19.044a2.094 2.094 0 01-2.092-2.092c0-.093.015-.181.027-.27a2.087 2.087 0 014.156.271 2.094 2.094 0 01-2.091 2.091M5.098 13.617a2.094 2.094 0 01-2.092-2.092c0-1.154.938-2.092 2.092-2.092a2.086 2.086 0 012.064 1.82c.012.09.028.18.028.272 0 .093-.016.182-.028.272a2.088 2.088 0 01-2.065 1.82m11.717-7.52c0-1.153.938-2.091 2.092-2.091 1.153 0 2.092.938 2.092 2.092a2.094 2.094 0 01-2.092 2.092 2.086 2.086 0 01-2.065-1.821c-.012-.09-.027-.178-.027-.271m2.092 7.757c-1.131 0-2.118.607-2.658 1.512l-8.122-3.192a3.114 3.114 0 000-1.3l8.122-3.192a3.092 3.092 0 002.658 1.513 3.098 3.098 0 10-3.028-2.448L7.756 9.94a3.092 3.092 0 00-2.658-1.513 3.098 3.098 0 000 6.196c1.13 0 2.117-.608 2.658-1.513l8.122 3.192a3.098 3.098 0 103.028-2.447"
            fillRule="evenodd"
        />
    </svg>
);

ShareAndroidSvg.displayName = 'ShareAndroidSvg';
export default ShareAndroidSvg;
